<template>
  <v-app>
    <v-app-bar app fixed dense flat clipped-left class="tb d-print-none">
      <router-link to="/"><v-toolbar-title to="/">BlogCMS</v-toolbar-title></router-link>
      <v-spacer></v-spacer>
      <v-btn icon to="/funktionen/profil" v-if="auth">
              <v-icon color="#3498db">{{account}}</v-icon>
      </v-btn>
    </v-app-bar>

    <vue-progress-bar></vue-progress-bar>
    
     <v-content class="content">
      <v-container fluid fill-height>
        <v-layout>
          <v-flex>
            <main>
              <router-view id="print"></router-view>
            </main>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<style scoped>
.tc{
  text-align: center;
}
@media print {
  .content {padding: 0 !important; z-index: 10;}
}
#list{
  overflow-x: auto;
  word-wrap: break-word;
}
</style>


<script>
import { fb } from './db'
import { db } from './db'
import { mdiAccount } from '@mdi/js'
  export default {
    name: 'App',
    data: () => ({
      account: mdiAccount,
      printer_off: true,
      auth: false
    }),
    props: {
      source: String
    },
    methods: {
      //
    },
    metaInfo: {
      title: 'BlogCMS',
      // all titles will be injected into this template
      titleTemplate: '%s'
    },
    updated(){
      var user = fb.auth().currentUser
      if (user != null) {
        this.auth = true
      } else {
        this.auth = false
      }
      if(!this.auth && this.$route.path !== '/funktionen/auth'){
          this.$router.push('/funktionen/auth')
      }
    },
    created(){
      //  [App.vue specific] When App.vue is first loaded start the progress bar
      this.$Progress.start()

      this.$router.beforeEach((to, from, next) => {
        if (to.meta.progress !== undefined) {
          let meta = to.meta.progress
          this.$Progress.parseMeta(meta)
        }
        this.$Progress.start()
        next()
      })
    },
    mounted(){
      var user = fb.auth().currentUser
      if (user != null) {
        this.auth = true
        if(this.$route.path !== '/'){
          this.$router.push('/')
        }
      } else {
        this.auth = false
      }
      if(user == null && !this.auth && this.$route.path !== '/funktionen/auth'){
          this.$router.push('/funktionen/auth')
      }
    }
  }
</script>
